import { Icon, type IconProps } from './Icon';

export function Document(props: IconProps) {
  return (
    <Icon {...props}>
      <rect x="6" y="3" width="12" height="18" rx="2" />
      <path d="M9.5 8h5M9.5 12h5M9.5 16h3" />
    </Icon>
  );
}
